/**
 * @generated SignedSource<<d0826090e60b59f4ea711d4c5ee2a884>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ExpenseCategoryFinancialBreakdownType = "EXPENSE_CATEGORY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DetailsExpenseCategoryLoader_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly currency: string | null;
  } | null;
  readonly project: {
    readonly rateCard: {
      readonly currency: string | null;
    } | null;
    readonly expenseCategoryFinancialBreakdown: ReadonlyArray<{
      readonly breakdownType: ExpenseCategoryFinancialBreakdownType | null;
      readonly expenseCategory: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly financialNumbers: {
        readonly baselineRevenue?: number | null;
        readonly baselineCost?: number | null;
        readonly baselineProfit?: number | null;
        readonly billableActualTimeAndExpenses?: number | null;
        readonly actualCost?: number | null;
        readonly actualProfit?: number | null;
        readonly billablePlannedTimeAndExpenses?: number | null;
        readonly plannedCost?: number | null;
        readonly plannedProfit?: number | null;
        readonly billableForecastTimeAndExpensesToComplete?: number | null;
        readonly forecastCostToComplete?: number | null;
        readonly forecastProfitToComplete?: number | null;
        readonly billableTotalTimeAndExpensesAtCompletion?: number | null;
        readonly totalCostAtCompletion?: number | null;
        readonly totalProfitAtCompletion?: number | null;
        readonly planVsBillableActualTimeAndExpenses?: number | null;
        readonly planVsActualCost?: number | null;
        readonly planVsActualProfit?: number | null;
        readonly planVsTotalBillableTimeAndExpensesAtCompletion?: number | null;
        readonly planVsTotalCostAtCompletion?: number | null;
        readonly planVsTotalProfitAtCompletion?: number | null;
        readonly baselineVsBillableActualTimeAndExpenses?: number | null;
        readonly baselineVsActualCost?: number | null;
        readonly baselineVsActualProfit?: number | null;
        readonly baselineVsBillableTotalTimeAndExpensesAtCompletion?: number | null;
        readonly baselineVsTotalCostAtCompletion?: number | null;
        readonly baselineVsTotalProfitAtCompletion?: number | null;
        readonly invoiced?: number | null;
        readonly paid?: number | null;
        readonly baselineMinutes?: number | null;
        readonly baselineVsRegisteredMinutes?: number | null;
        readonly baselineVsTotalTimeAtCompletion?: number | null;
        readonly registeredMinutes?: number | null;
        readonly scopeApprovedMinutes?: number | null;
        readonly registeredVsScopeApprovedMinutes?: number | null;
        readonly scopeApprovedVsRegisteredMinutes?: number | null;
        readonly forecastTimeToComplete?: number | null;
        readonly totalTimeAtCompletion?: number | null;
        readonly totalTimeAtCompletionVsScopeApprovedMinutes?: number | null;
        readonly scopeApprovedVsTotalTimeAtCompletion?: number | null;
      } | null;
    } | null>;
    readonly aggregatedExpenseCategoryFinancialBreakdown: ReadonlyArray<{
      readonly breakdownType: ExpenseCategoryFinancialBreakdownType | null;
      readonly expenseCategory: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly aggregatedFinancialNumbers: ReadonlyArray<string | null> | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "DetailsExpenseCategoryLoader_viewer";
};
export type DetailsExpenseCategoryLoader_viewer$key = {
  readonly " $data"?: DetailsExpenseCategoryLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DetailsExpenseCategoryLoader_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v2 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v3 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v4 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v5 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v6 = {
  "kind": "Literal",
  "name": "filterRowsWithNoValues",
  "value": true
},
v7 = {
  "kind": "Variable",
  "name": "phaseId",
  "variableName": "phaseId"
},
v8 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v9 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v10 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v11 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breakdownType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseCategory",
  "kind": "LinkedField",
  "name": "expenseCategory",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "actualCost"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "actualProfit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aggregate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aggregateLevel"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineCost"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineMinutes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineProfit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineRevenue"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineVsActualCost"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineVsActualProfit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineVsBillableActualTimeAndExpenses"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineVsRegisteredMinutes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineVsTotalCostAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineVsTotalProfitAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "baselineVsTotalTimeAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "billableActualTimeAndExpenses"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "billableForecastTimeAndExpensesToComplete"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "billablePlannedTimeAndExpenses"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "billableTotalTimeAndExpensesAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forecastCostToComplete"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forecastProfitToComplete"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forecastTimeToComplete"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "invoiced"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "paid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "phaseId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "planVsActualCost"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "planVsActualProfit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "planVsBillableActualTimeAndExpenses"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "planVsTotalBillableTimeAndExpensesAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "planVsTotalCostAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "planVsTotalProfitAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plannedCost"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plannedProfit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "registeredMinutes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "registeredVsScopeApprovedMinutes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scopeApprovedMinutes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scopeApprovedVsRegisteredMinutes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scopeApprovedVsTotalTimeAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "totalCostAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "totalProfitAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "totalTimeAtCompletion"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "totalTimeAtCompletionVsScopeApprovedMinutes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetailsExpenseCategoryLoader_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "rateCard",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "concreteType": "ExpenseCategoryFinancialBreakdown",
          "kind": "LinkedField",
          "name": "expenseCategoryFinancialBreakdown",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialNumbers",
              "kind": "LinkedField",
              "name": "financialNumbers",
              "plural": false,
              "selections": [
                {
                  "condition": "baselineRevenue",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineRevenue",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineCost",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineCost",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineProfit",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineProfit",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "billableActualTimeAndExpenses",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "billableActualTimeAndExpenses",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "actualCost",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "actualCost",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "actualProfit",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "actualProfit",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "billablePlannedTimeAndExpenses",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "billablePlannedTimeAndExpenses",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "plannedCost",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "plannedCost",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "plannedProfit",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "plannedProfit",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "billableForecastTimeAndExpensesToComplete",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "billableForecastTimeAndExpensesToComplete",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "forecastCostToComplete",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "forecastCostToComplete",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "forecastProfitToComplete",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "forecastProfitToComplete",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "billableTotalTimeAndExpensesAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "billableTotalTimeAndExpensesAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "totalCostAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalCostAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "totalProfitAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalProfitAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "planVsBillableActualTimeAndExpenses",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "planVsBillableActualTimeAndExpenses",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "planVsActualCost",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "planVsActualCost",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "planVsActualProfit",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "planVsActualProfit",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "planVsTotalBillableTimeAndExpensesAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "planVsTotalCostAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "planVsTotalCostAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "planVsTotalProfitAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "planVsTotalProfitAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineVsBillableActualTimeAndExpenses",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineVsBillableActualTimeAndExpenses",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineVsActualCost",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineVsActualCost",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineVsActualProfit",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineVsActualProfit",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineVsTotalCostAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineVsTotalCostAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineVsTotalProfitAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineVsTotalProfitAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "invoiced",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "invoiced",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "paid",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "paid",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineMinutes",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineMinutes",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineVsRegisteredMinutes",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineVsRegisteredMinutes",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "baselineVsTotalTimeAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineVsTotalTimeAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "registeredMinutes",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "registeredMinutes",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "scopeApprovedMinutes",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scopeApprovedMinutes",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "registeredVsScopeApprovedMinutes",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "registeredVsScopeApprovedMinutes",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "scopeApprovedVsRegisteredMinutes",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scopeApprovedVsRegisteredMinutes",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "forecastTimeToComplete",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "forecastTimeToComplete",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "totalTimeAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalTimeAtCompletion",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "totalTimeAtCompletionVsScopeApprovedMinutes",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "scopeApprovedVsTotalTimeAtCompletion",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scopeApprovedVsTotalTimeAtCompletion",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "aggregateLevel",
              "variableName": "aggregateLevel"
            },
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "aggregates.0",
                  "variableName": "aggregate"
                }
              ],
              "kind": "ListValue",
              "name": "aggregates"
            },
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "concreteType": "AggregatedExpenseCategoryFinancialBreakdown",
          "kind": "LinkedField",
          "name": "aggregatedExpenseCategoryFinancialBreakdown",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aggregatedFinancialNumbers",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "88043592334ccfa1d91a2c734ca15f14";

export default node;
